<template>
    <div class="content">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="基本信息" name="first">
                <el-descriptions title="" :column="1" border size="medium" labelClassName="custom-label" v-loading="loadingBtn">
                    <el-descriptions-item label="生效开始日期">{{ result.PriceList_StartTime }}</el-descriptions-item>
                    <el-descriptions-item label="生效结束日期">{{ result.PriceList_EndTime }}</el-descriptions-item>
                </el-descriptions>
            </el-tab-pane>
            <el-tab-pane label="应用商品" name="second">
                <div class="content-head">
                    <div class="content-head-title">价格单搜索</div>
                    <el-form :inline="true" class="demo-form-inline">
                        <el-form-item label="类别">
                            <el-select v-model="Cate_ID" clearable filterable placeholder="请选择" @change="handleChange($event, 1)" class="el-select-medium">
                                <el-option v-for="item in cascaderData" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>

                            <el-select v-if="cascaderData1 && cascaderData1.length > 0" v-model="Cate_ID1" clearable filterable placeholder="请选择" @change="handleChange($event, 2)" style="margin: 0px 10px" class="el-select-medium">
                                <el-option v-for="item in cascaderData1" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>

                            <el-select v-if="cascaderData2 && cascaderData2.length > 0" v-model="Cate_ID2" clearable filterable placeholder="请选择" @change="handleChange" class="el-select-medium">
                                <el-option v-for="item in cascaderData2" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="商品名称">
                            <el-input autocomplete="on" name="keyword"  v-model="params.keyword" class="el-select-medium" placeholder="请输入商品名称进行搜索"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="getProductPriceList(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="onRefresh" icon="el-icon-refresh">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="content-table">
                    <div class="content-table-title">价格单列表</div>
                    <el-table :data="result.Products" :height="maxheight" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                        <el-table-column prop="Product_ID" label="ID" width="100" align="center"></el-table-column>
                        <el-table-column prop="Product_SubName" label="商品名称" align="left"></el-table-column>
                        <el-table-column label="价格" align="center" width="100">
                            <template slot-scope="scope">
                                <span>￥ {{ scope.row.Product_Price.toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div>
                        <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue';
export default {
    name: 'priceList',
    components: {
        Pagination
    },
    data() {
        return {
            activeName: 'first',
            params: {
                keyword: '',
                Cate_ID: ''
            },
            paginationOptions: {
                Page: 1,
                total: 0,
                PageSize: 40
            },
            result: {
                PriceList_StartTime: '',
                PriceList_EndTime: '',
                PriceList_Name: '',
                PriceList_Code: '',
                PriceList_Version: '',
                Products: []
            },
            loadingBtn: false,
            cascaderData: [],
            cascaderData1: [],
            cascaderData2: [],
            Cate_ID: '',
            Cate_ID1: '',
            Cate_ID2: '',
            maxheight: 'auto'
        };
    },
    mounted() {
        this.getAllCategory();
        this.getProductPriceList();
    },
    methods: {
        onRefresh() {
            this.params = {
                keyword: '',
                Cate_ID: ''
            };
            this.cascaderData1 = [];
            this.cascaderData2 = [];
            (this.Cate_ID = ''), (this.Cate_ID1 = ''), (this.Cate_ID2 = ''), this.getProductPriceList(true);
        },
        handleChange(e, type) {
            if (type == 1) {
                this.cascaderData1 = [];
                this.cascaderData2 = [];
                this.Cate_ID1 = '';
                this.Cate_ID2 = '';
                let obj = this.cascaderData.find((item) => {
                    console.log(item, e);
                    return item.value == e;
                });
                if (obj && obj.children) {
                    this.cascaderData1 = obj.children;
                }
                console.log(e, obj, type, 'eeeeee');
            }
            if (type == 2) {
                this.Cate_ID2 = '';
                this.cascaderData2 = [];
                let obj = this.cascaderData1.find((item) => {
                    console.log(item, e);
                    return item.value == e;
                });
                if (obj && obj.children) {
                    this.cascaderData2 = obj.children;
                }
                console.log(e, obj, type, 'eeeeee');
            }

            if (this.Cate_ID2) {
                this.params.Cate_ID = this.Cate_ID2;
                return;
            }
            if (this.Cate_ID1) {
                this.params.Cate_ID = this.Cate_ID1;
                return;
            }
            if (this.Cate_ID) {
                this.params.Cate_ID = this.Cate_ID;
            }
        },
        buildCascaderData(data) {
            const idMap = {};
            // 首先将所有项映射到一个对象中，键是 Cate_ID
            data.forEach((item) => {
                idMap[item.Cate_ID] = {
                    value: item.Cate_ID,
                    label: item.Cate_Name,
                    children: []
                };
            });
            // 然后将这些项组织成树形结构
            const result = [];
            data.forEach((item) => {
                const parent = idMap[item.Cate_ParentID];
                if (parent) {
                    // 如果有父级，将此项加入父级的 children 中
                    parent.children.push(idMap[item.Cate_ID]);
                } else {
                    // 如果没有父级（Cate_ParentID 为 0），则为根节点
                    result.push(idMap[item.Cate_ID]);
                }
            });
            // 删除空的 children 属性
            function removeEmptyChildren(nodes) {
                nodes.forEach((node) => {
                    if (node.children && node.children.length === 0) {
                        delete node.children;
                    } else if (node.children) {
                        removeEmptyChildren(node.children); // 递归处理子节点
                    }
                });
            }
            removeEmptyChildren(result);
            return result;
        },
        // 获取所有商品分类
        getAllCategory() {
            this.$newsApi.getAllCategory().then((res) => {
                if (res.data.Resultcode == 0) {
                    let categoryOptions = res.data.data;
                    this.cascaderData = this.buildCascaderData(categoryOptions);
                    console.log(this.cascaderData, '=========???');
                }
            });
        },
        getProductPriceList(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            let params = {
                json: JSON.stringify({ ...this.params, ...this.paginationOptions })
                // Page: this.paginationOptions.Page,
                // PageSize: this.paginationOptions.PageSize
            };
            this.$newsApi
                .getProductPriceList(params)
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.result = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.paginationOptions.Page = 1;
            this.getProductPriceList();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getProductPriceList();
        },
        handleClick() {
            this.$nextTick(() => {
                this.maxheight = this.$setTableMaxHeight('.app-main-content', '.content-head', 230);
            });
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/.el-tabs__nav-wrap::after {
    background: #fff !important;
}
/deep/.custom-label {
    width: 150px;
}
/deep/.el-form-item__label {
    font-weight: 500 !important;
}
/deep/.el-descriptions-item__label {
    text-align: right !important;
}
.content {
    padding: 10px 20px 20px 20px;
    background: #fff;
    height: calc(100vh - 104px);
    overflow: auto;
}
.content-head {
    background: #fff;
    padding: 0px 0px 10px 0px;
    border-radius: 2px;
}
.content-head-title {
    line-height: 50px;
}
.content-table-title {
    line-height: 50px;
}
.content-table {
    border-radius: 2px;
    background: #fff;
    padding: 0px 0px 20px 0px;
    cursor: pointer;
}
</style>
